import { Box, Grid, Typography } from "@mui/material";

import { AppFormType } from "components/Forms/AppForm";

interface ProgressPointDateInputSectionProps {
  productForm: AppFormType | { AppField: any };
}

const ProgressPointDateInputSection = ({
  productForm,
}: ProgressPointDateInputSectionProps) => {
  return (
    <Box className="mb-4">
      <Typography variant="body1" className="mb-2">
        PROJECTED 90-DAY COMPLETION DATES
      </Typography>
      <div className="border p-3 rounded">
        <Typography
          variant="body1"
          className="mb-3"
          sx={{ color: "text.secondary" }}
        >
          Committed vendor and CCTL evaluation schedules with Progress Point
          milestones that achieve completion in 90 days.
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <productForm.AppField name="st_evaluation_date">
                {(field: any) => (
                  <field.TextInput
                    label="Progress Point 3: ST Evaluation Completed:"
                    type="date"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              </productForm.AppField>
              <productForm.AppField name="testing_complete_date">
                {(field: any) => (
                  <field.TextInput
                    label="Progress Point 5: Testing Complete:"
                    type="date"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              </productForm.AppField>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <productForm.AppField name="test_ready_date">
                {(field: any) => (
                  <field.TextInput
                    label="Progress Point 4: Test Ready:"
                    type="date"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              </productForm.AppField>
              <productForm.AppField name="evaluator_checkout_date">
                {(field: any) => (
                  <field.TextInput
                    label="Progress Point 6: Evaluator Checkout:"
                    type="date"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              </productForm.AppField>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default ProgressPointDateInputSection;
